import { FooterComponentItem } from '@app-shared/components/footers/footer.model';
import { ClientConfig, DEFAULT_CLIENT_CONFIG } from './config.base';
import { navigationRoutes as BaseLinks, RouteParams } from './links.base';
import { TargatelematicsComponent } from '@app-shared/components/footers/targatelematics/targatelematics.component';

export const CLIENT_CONFIG: ClientConfig = {
  clientName: 'targatelematics',
  ...DEFAULT_CLIENT_CONFIG,
  logo: {
    loginPageLogo: 'assets/targatelematics/login-page-logo.jpg',
    lightLogo: 'assets/targatelematics/light-logo.svg',
    darkLogo: 'assets/targatelematics/dark-logo.svg',
    alt: 'LightMetrics',
    width: '148px',
    height: '36px',
  },
  showSurveyButton: true,
  showCopyrightText: true,
  showPrivacyPolicyLink: true,
  disableSuprsendNotification: false,
  landingPageDetails: {
    backgroundImage: {
      src: 'assets/targatelematics/login-page-bg2-min.jpg',
    },
    brandImage: {
      src: 'assets/targatelematics/dark-logo.svg',
    },
    headerImage: {
      src: 'assets/targatelematics/login-page-header.svg',
    },
    tagline: 'lmpresalesTagline',
    footer: new FooterComponentItem(TargatelematicsComponent),
  },
  showLandingPage: true,
};

export const navigationRoutes: RouteParams[] = CLIENT_CONFIG.allowedRoutes.map((x) => BaseLinks[x]);
